import { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../context/AuthContext';
import { premiumPlans } from '../mock';

export function mergePlans(serverPlans) {
  return premiumPlans.map(p => {
    const s = (serverPlans || []).find(x => x.id === p.id);
    return s ? { ...p, price: s.price } : p;
  });
}

export function usePlans() {
  const [plans, setPlans] = useState(premiumPlans);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    axios.get(`${API}/plans`).then(r => setPlans(mergePlans(r.data))).catch(() => {}).finally(() => setLoaded(true));
  }, []);
  const minPrice = Math.min(...plans.map(p => p.price));
  return { plans, minPrice, loaded, setPlans };
}
